import Model from './Model';

export enum AdminAction {
    LOGIN = 'login',
    LOGOUT = 'logout',
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
}

export default class AdminActivity extends Model {
    readonly id: number;
    readonly created_at: string;
    readonly ip_address: string | null;
    readonly user_agent: string | null;
    readonly admin_id: number;
    readonly action: AdminAction;
    readonly action_details: {} | null;
    readonly loggable_id: number | null;
    readonly loggable_type: string | null;

    constructor(data: any) {
        super();
        this.assignDataToProps(data, [
            'id',
            'created_at',
            'ip_address',
            'user_agent',
            'admin_id',
            'action',
            'action_details',
            'loggable_id',
            'loggable_type',
        ]);
    }
}
